import React from "react";
import Footer from "../components/footer/Footer";
import HirePageBanner from "../components/HirePageBanner/HirePageBanner";
import DevelopmentPerformance from "../components/DevelopmentPerformance/DevelopmentPerformance";
import SecondFaq from "../components/secondFaq/SecondFaq";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import { Helmet } from "react-helmet";
import HirePageExperties from "../components/hirepageExperties/HirePageExperties";
import HirePageSteps from "../components/hire-page-steps/HirePageSteps";
import HireExpertFacts from "../components/hire-expert-facts/HireExpertFacts";
import HirePageEngagmentModels from "../components/hire-page-engagment-models/HirePageEngagmentModels";
import HirePageAppIdea from "../components/hire-page-app-idea/HirePageAppIdea";
import ContactSection from "../components/contactSection/ContactSection";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import HireCombinationSection from "../components/hire-combination-sectiono/HireCombinationSection";
import CoverTheStack from "../components/coverthestack/CoverTheStack";

// Import the single, centralized data object
// import { hireDjangoPageData } from "../data/hire-django-data"; // Adjust this path based on your project structure
import { useTranslation } from "react-i18next";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import SimpleModels from "../components/simpleEngagementModels";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import OurServices from "../components/our-services/OurServices";
import { hireDjangoEngagementModeContent } from "../data/hire-django-data";

const HireDjango = () => {
  //   // Destructure data for easier access within the component (optional, but clean)
  //   const {
  //     helmet,
  //     hirePageBanner,
  //     hirePageExperties,
  //     developmentPerformance,
  //     hireCombinationSection,
  //     hirePageSteps,
  //     coverTheStack,
  //     hireExpertFacts,
  //     hirePageAppIdea,
  //     hirePageEngagementModels,
  //     secondFaq,
  //     trendsInsights,
  //   } = hireDjangoPageData;

  const { t } = useTranslation("hireDjangoPage");
  const helmet = t("helmet", { returnObjects: true });
  const hirePageBanner = t("hirePageBanner", { returnObjects: true });
  const hirePageExperties = t("hirePageExperties", { returnObjects: true });
  const developmentPerformance = t("developmentPerformance", {
    returnObjects: true,
  });
  const hireCombinationSection = t("hireCombinationSection", {
    returnObjects: true,
  });
  const hirePageSteps = t("hirePageSteps", { returnObjects: true });
  const coverTheStack = t("coverTheStack", { returnObjects: true });
  const hireExpertFacts = t("hireExpertFacts", { returnObjects: true });
  const hirePageAppIdea = t("hirePageAppIdea", { returnObjects: true });
  const hirePageEngagementModels = t("hirePageEngagementModels", {
    returnObjects: true,
  });
  const secondFaq = t("secondFaq", { returnObjects: true });
  const trendsInsights = t("trendsInsights", { returnObjects: true });

  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>Hire Remote Django Developers in 24 Hours | Bitsclan</title>
        <meta name="description" content="Bitsclan offers top remote Django developers on an hourly, part-time, or full-time contract basis. Hire our pre-vetted Django experts to build secure, scalable, and high-performing web applications." />
      </Helmet>

      <MegaMenu />

      <HirePageBanner
        diffBannerBackgroundImage={hirePageBanner?.diffBannerBackgroundImage}
        image={hirePageBanner?.image}
        mainHeading={hirePageBanner?.mainHeading}
        content={hirePageBanner?.content}
        btnText={hirePageBanner?.btnText}
        bannerList={hirePageBanner?.bannerList}
      />

      <OurServices
        mainHeading={hirePageExperties?.heading}
        description={hirePageExperties?.description}
        servicesCardsData={hirePageExperties?.servicesData}
        buttonText="Schedule a Call Today"
      />

      <DevelopmentPerformance
        buttonText={developmentPerformance.btnText}
        heading={developmentPerformance?.heading}
        greenHeading={developmentPerformance?.greenHeading}
        subHeading={developmentPerformance?.subHeading}
        solutions={developmentPerformance?.solutions}
      />

      <HireCombinationSection
        combinations={hireCombinationSection?.combinations}
        heading={hireCombinationSection?.heading}
        description={hireCombinationSection?.description}
      />

      <HirePageSteps
        buttonText={hirePageSteps.btnText}
        heading={hirePageSteps?.heading}
        subHeading={hirePageSteps?.subHeading}
        steps={hirePageSteps?.steps}
      />

      <CoverTheStack
        whereStart={coverTheStack?.whereStart}
        mainHeading={coverTheStack?.mainHeading}
        subHeading={coverTheStack?.subHeading}
        tabs={coverTheStack?.tabs}
        tabItems={coverTheStack?.tabItems}
      />

      <HireExpertFacts
        buttonText={hireExpertFacts.btnText}
        heading={hireExpertFacts?.heading}
        greenHeading={hireExpertFacts?.greenHeading}
        facts={hireExpertFacts?.facts}
        diffBannerBackgroundImage={hireExpertFacts?.diffBannerBackgroundImage}
      />

      <HirePageAppIdea
        heading={hirePageAppIdea?.heading}
        content={hirePageAppIdea?.content}
      />

      {/* <HirePageEngagmentModels
        buttonText={hirePageEngagementModels.btnText}
        heading={hirePageEngagementModels?.headingContent}
        content={hirePageEngagementModels?.discription}
        hiringDetails={hirePageEngagementModels?.hiringDetails}
      /> */}

      <SimpleModels content={hireDjangoEngagementModeContent} />

      {/* For components without specific data in the original object, they remain as is */}
      <TrendsInsights
        specificClass={trendsInsights?.specificClass}
        category={trendsInsights?.category}
      />

      <SecondFaq
        specificClass={secondFaq?.specificClass}
        faqs={secondFaq?.faqs}
        mainHeading={secondFaq?.mainHeading}
        subHeading={secondFaq?.subHeading}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={footerCtaContent} />
      <Footer />
    </>
  );
};

export default HireDjango;
